import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@/state'

import { wageringSelector } from '@/state/wagering-contribution/slices/index.slices'
import {
  GlobalUIActions,
  setDialogAction,
} from '@/state/ui/global/slices/index.slices'
import { DialogsEnum } from '@/enums'

import { useWageringActions } from './use-wagering-actions.hook'
import { WageringLibraryHeadProps } from '../types'

export const useWageringTable = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const { wageringCategory, isLoading } = useSelector(wageringSelector)

  const { deleteWageringCategory, setCurrentWageringCategory } =
    useWageringActions()

  const headCells: WageringLibraryHeadProps[] = [
    { id: 'isBlocked', label: t('labels.isBlocked'), width: 50 },
    { id: 'code', label: t('labels.category'), width: 180 },
    { id: 'percentage', label: t('labels.percentage'), width: 150 },
  ]

  const handleDeleteWagering = (
    id: string,
    anchorPosition: { top: number; left: number },
  ) => {
    dispatch(
      GlobalUIActions.setPopoverConfirmAction({
        action: t('messages.delete'),
        anchorPosition,
        open: true,
        type: t('labels.wageringContribution').toLowerCase(),
        handler: () => deleteWageringCategory(id),
      }),
    )
  }

  const handleEditWagering = (id: number) => {
    setCurrentWageringCategory(
      wageringCategory.find((wagering) => wagering.id === id),
    )
    dispatch(
      setDialogAction({
        open: true,
        id: DialogsEnum.DIALOG_WAGERING_CONTRIBUTION_FORM,
      }),
    )
  }

  return {
    handleDeleteWagering,
    handleEditWagering,
    isLoading,
    wageringCategory,
    headCells,
  }
}
